import { Button } from "@/components/ui/button";
import { useTracking } from "@/hooks/use-tracking";
import { jobViewActionsTestIds } from "@/lib/data-test-ids/jobs.data-test-ids";

interface ExternalApplicationLinkButtonProps {
  jobUrl: string;
  jobId: string | number;
}

export default function ExternalApplicationLinkButton({
  jobUrl,
  jobId,
}: ExternalApplicationLinkButtonProps) {
  const { trackExternalApplyClicked } = useTracking();

  const handleClick = () => {
    trackExternalApplyClicked({
      jobId: String(jobId),
      jobUrl,
    });
  };

  return (
    <Button
      asChild
      className="h-12 w-full rounded-lg border border-border bg-card text-base font-semibold text-foreground shadow-none transition-colors hover:bg-surface-subtle"
    >
      <a
        href={jobUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Open external application page in new tab"
        data-testid={`${jobViewActionsTestIds.JOB_VIEW_ACTIONS_EXTERNAL_APPLICATION_LINK}-${jobId}`}
        onClick={handleClick}
      >
        Link to External Application
      </a>
    </Button>
  );
}
